import { set, toString } from 'lodash-es';
import { setTaskDetailResMsg } from '../actions/taskDetailActions';
import baseApi, { TAGS } from './baseApi';
import { sentryCaptureException } from '../utils/sentryUtils';
import { opsSystemApi } from './opsSystemApi';

/***************************************** API *****************************************/
const taxProConsultationApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getTaxPros: builder.query({
      query: () => ({
        url: 'web-ops/tax-pro-consultation/tax-pros',
        method: 'GET'
      }),
      transformResponse: (response) => response.data.taxPros
    }),
    updateTaxProAssignment: builder.mutation({
      query: ({ userId, taxProEmail }) => ({
        url: 'web-ops/tax-pro-consultation/reassign-tax-pro',
        method: 'POST',
        body: { userId, taxProEmail }
      }),
      invalidatesTags: [TAGS.TASK],
      async onQueryStarted({ taxProEmail, taxProName, taskId }, { dispatch, queryFulfilled }) {
        const optimisticUpdate = dispatch(
          opsSystemApi.util.updateQueryData('getTask', toString(taskId), (task) =>
            set(task, 'taxProAssignment', {
              taxProName,
              taxProEmail
            })
          )
        );
        try {
          await queryFulfilled;
        } catch (e) {
          optimisticUpdate.undo();
          sentryCaptureException(e);
          dispatch(
            setTaskDetailResMsg({
              error: e?.data?.msg || 'Error occurred',
              title: 'Error updating tax pro assignment'
            })
          );
        }
      }
    })
  })
});

/***************************************** HOOKS *****************************************/
export const { useGetTaxProsQuery, useUpdateTaxProAssignmentMutation } = taxProConsultationApi;
